export default __webpack_public_path__ + "assets/images/1.3e6e54.png";